/* ===================================================================
   IMPERO — theme.js
   Adapted from the prototype's per-page scripts. The big functional
   change from the prototype: cart state now lives in Shopify (via the
   Cart AJAX API) instead of localStorage, so it survives page loads,
   works with real inventory, and is what actually reaches checkout.
   =================================================================== */

document.addEventListener('DOMContentLoaded', function () {

  /* ---------- Header brand: crossfade wordmark -> logo mark on scroll ---------- */
  (function () {
    var logo = document.querySelector('.brand-left img.brand-mark');
    var text = document.querySelector('.brand-left img.brand-wordmark');
    if (!logo || !text) return;

    function updateBrand() {
      var threshold = window.innerHeight * 0.5;
      if (window.scrollY > threshold) {
        logo.classList.add('visible');
        text.classList.add('hidden');
      } else {
        logo.classList.remove('visible');
        text.classList.remove('hidden');
      }
    }

    updateBrand();
    window.addEventListener('scroll', updateBrand, { passive: true });
    window.addEventListener('resize', updateBrand);
  })();

  /* ---------- Inline predictive search ---------- */
  (function () {
    var wrap = document.getElementById('searchBarWrap');
    var openBtn = document.getElementById('openSearch');
    var input = document.getElementById('searchInput');
    var dropdown = document.getElementById('searchDropdown');
    var indexEl = document.getElementById('impero-search-index');
    if (!wrap || !openBtn || !input || !dropdown) return;

    var PRODUCTS = [];
    if (indexEl) {
      try { PRODUCTS = JSON.parse(indexEl.textContent); } catch (e) { PRODUCTS = []; }
    }

    function closeDropdown() {
      dropdown.classList.remove('show');
      dropdown.innerHTML = '';
    }

    function renderDropdown(list) {
      if (list.length === 0) {
        dropdown.innerHTML = '<div class="search-empty">No products found.</div>';
      } else {
        dropdown.innerHTML = list.map(function (p) {
          return '<a class="search-result" href="' + p.url + '">' +
            '<img src="' + p.img + '" alt="' + p.name + '">' +
            '<div class="sr-info"><span class="sr-name">' + p.name + '</span><span class="sr-price">' + p.price + '</span></div>' +
            '</a>';
        }).join('');
      }
      dropdown.classList.add('show');
    }

    function filterProducts(query) {
      query = query.trim().toLowerCase();
      if (query === '') { closeDropdown(); return; }
      var matches = PRODUCTS.filter(function (p) {
        return p.name.toLowerCase().indexOf(query) !== -1;
      });
      renderDropdown(matches);
    }

    function openBar() {
      wrap.classList.add('open');
      setTimeout(function () { input.focus(); }, 250);
    }

    function closeBar() {
      wrap.classList.remove('open');
      input.value = '';
      closeDropdown();
    }

    openBtn.addEventListener('click', function (e) {
      e.preventDefault();
      wrap.classList.contains('open') ? closeBar() : openBar();
    });

    input.addEventListener('input', function () { filterProducts(input.value); });

    document.addEventListener('click', function (e) {
      if (!wrap.classList.contains('open')) return;
      if (wrap.contains(e.target) || e.target === openBtn) return;
      closeBar();
    });

    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && wrap.classList.contains('open')) closeBar();
    });
  })();

  /* ---------- Account / signup modals ---------- */
  (function () {
    var accountOverlay = document.getElementById('accountOverlay');
    var signupOverlay = document.getElementById('signupOverlay');
    var openBtn = document.getElementById('openAccount');
    var openBtnFooter = document.getElementById('openAccountFooter');
    var closeBtn = document.getElementById('closeAccount');
    var openSignupBtn = document.getElementById('openSignup');
    var closeSignupBtn = document.getElementById('closeSignup');
    var backToLoginBtn = document.getElementById('backToLogin');
    if (!accountOverlay) return;

    function openAccount(e) { if (e) e.preventDefault(); accountOverlay.classList.add('open'); }
    function closeAccount() { accountOverlay.classList.remove('open'); }

    if (openBtn) openBtn.addEventListener('click', openAccount);
    if (openBtnFooter) openBtnFooter.addEventListener('click', openAccount);
    if (closeBtn) closeBtn.addEventListener('click', closeAccount);
    accountOverlay.addEventListener('click', function (e) { if (e.target === accountOverlay) closeAccount(); });

    if (signupOverlay) {
      if (openSignupBtn) {
        openSignupBtn.addEventListener('click', function (e) {
          e.preventDefault();
          closeAccount();
          signupOverlay.classList.add('open');
        });
      }
      if (closeSignupBtn) closeSignupBtn.addEventListener('click', function () { signupOverlay.classList.remove('open'); });
      if (backToLoginBtn) {
        backToLoginBtn.addEventListener('click', function (e) {
          e.preventDefault();
          signupOverlay.classList.remove('open');
          openAccount();
        });
      }
      signupOverlay.addEventListener('click', function (e) { if (e.target === signupOverlay) signupOverlay.classList.remove('open'); });
    }

    document.addEventListener('keydown', function (e) {
      if (e.key !== 'Escape') return;
      closeAccount();
      if (signupOverlay) signupOverlay.classList.remove('open');
    });
    /* Note: unlike the prototype, these forms are NOT preventDefault()'d —
       they submit to Shopify's real customer login/register routes. */
  })();

  /* ---------- Expandable panels (payment options / product details) ---------- */
  (function () {
    function wireToggle(btnId, panelId) {
      var btn = document.getElementById(btnId);
      var panel = document.getElementById(panelId);
      if (!btn || !panel) return;
      btn.addEventListener('click', function () {
        var isOpen = panel.classList.toggle('open');
        btn.setAttribute('aria-expanded', isOpen ? 'true' : 'false');
      });
    }
    wireToggle('paymentToggle', 'paymentPanel');
    wireToggle('detailsToggle', 'detailsPanel');
  })();

  /* ---------- FAQ accordion ---------- */
  (function () {
    var items = document.querySelectorAll('.faq-item');
    items.forEach(function (item) {
      var btn = item.querySelector('.faq-question');
      var panel = item.querySelector('.faq-answer');
      if (!btn || !panel) return;
      btn.addEventListener('click', function () {
        var isOpen = btn.getAttribute('aria-expanded') === 'true';
        if (isOpen) {
          btn.setAttribute('aria-expanded', 'false');
          panel.style.maxHeight = null;
        } else {
          btn.setAttribute('aria-expanded', 'true');
          panel.style.maxHeight = panel.scrollHeight + 'px';
        }
      });
    });
  })();

  /* ---------- Size guide modal (per-product metafield data) ---------- */
  (function () {
    var overlay = document.getElementById('sizeGuideOverlay');
    var openBtn = document.getElementById('openSizeGuide');
    var closeBtn = document.getElementById('closeSizeGuide');
    var unitCmBtn = document.getElementById('unitCm');
    var unitInBtn = document.getElementById('unitIn');
    var tbody = document.getElementById('sizeTableBody');
    var thead = document.getElementById('sizeTableHead');
    var dataEl = document.getElementById('size-guide-data');
    if (!overlay || !openBtn || !dataEl) return;

    var rows = [];
    try { rows = JSON.parse(dataEl.textContent) || []; } catch (e) { rows = []; }
    if (!rows.length) return;

    var sizeKeys = Object.keys(rows[0]).filter(function (k) { return k !== 'label'; });
    var unit = 'cm';

    function cmToIn(cm) { return Math.round(cm * 0.3937 * 10) / 10; }

    function render() {
      thead.innerHTML = '<th>Size</th>' + sizeKeys.map(function (s) { return '<th>' + s + '</th>'; }).join('');
      tbody.innerHTML = rows.map(function (row) {
        var cells = sizeKeys.map(function (s) {
          var cm = row[s];
          var val = unit === 'cm' ? cm : cmToIn(cm);
          return '<td>' + val + (unit === 'cm' ? '' : '"') + '</td>';
        }).join('');
        return '<tr><td>' + row.label + '</td>' + cells + '</tr>';
      }).join('');
    }

    openBtn.addEventListener('click', function () { render(); overlay.classList.add('open'); });
    if (closeBtn) closeBtn.addEventListener('click', function () { overlay.classList.remove('open'); });
    overlay.addEventListener('click', function (e) { if (e.target === overlay) overlay.classList.remove('open'); });

    if (unitCmBtn) unitCmBtn.addEventListener('click', function () {
      unit = 'cm'; unitCmBtn.classList.add('active'); if (unitInBtn) unitInBtn.classList.remove('active'); render();
    });
    if (unitInBtn) unitInBtn.addEventListener('click', function () {
      unit = 'in'; unitInBtn.classList.add('active'); if (unitCmBtn) unitCmBtn.classList.remove('active'); render();
    });
  })();

  /* ---------- Quantity stepper ---------- */
  (function () {
    document.querySelectorAll('.qty-row').forEach(function (row) {
      var minus = row.querySelector('.qty-minus');
      var plus = row.querySelector('.qty-plus');
      var val = row.querySelector('.qty-value');
      var input = row.querySelector('.qty-input');
      if (!minus || !plus || !val) return;

      function sync() { if (input) input.value = val.textContent; }

      minus.addEventListener('click', function () {
        var n = parseInt(val.textContent, 10) || 1;
        if (n > 1) n--;
        val.textContent = n;
        sync();
      });
      plus.addEventListener('click', function () {
        var n = parseInt(val.textContent, 10) || 1;
        n++;
        val.textContent = n;
        sync();
      });
    });
  })();

  /* ---------- Product image gallery (click-to-switch thumbnails) ---------- */
  (function () {
    var mainImg = document.getElementById('galleryMainImg');
    var thumbs = document.querySelectorAll('.gallery-thumb');
    if (!mainImg || !thumbs.length) return;

    thumbs.forEach(function (btn) {
      btn.addEventListener('click', function () {
        var src = btn.getAttribute('data-img');
        if (!src || btn.classList.contains('active')) return;
        var alt = btn.getAttribute('data-alt') || mainImg.alt;

        thumbs.forEach(function (b) { b.classList.remove('active'); });
        btn.classList.add('active');

        mainImg.style.opacity = '0';
        setTimeout(function () {
          mainImg.setAttribute('src', src);
          mainImg.setAttribute('alt', alt);
          mainImg.style.opacity = '1';
        }, 150);
      });
    });
  })();

  /* ---------- Store grid: sort + color/size/price filters ---------- */
  (function () {
    var grid = document.querySelector('.product-grid');
    var cards = Array.prototype.slice.call(document.querySelectorAll('.product-card'));
    var toggles = document.querySelectorAll('.filter-pill, .filter-swatch');
    var priceSlider = document.getElementById('priceSlider');
    var priceValueEl = document.getElementById('priceValue');
    var clearBtn = document.getElementById('clearFilters');
    var emptyMsg = document.getElementById('filterEmpty');
    var sortSelect = document.getElementById('sortSelect');
    if (cards.length === 0 || !priceSlider || !grid) return;

    var activeColors = new Set();
    var activeSizes = new Set();

    function applyFilters() {
      var maxPrice = parseFloat(priceSlider.value);
      var visibleCount = 0;

      cards.forEach(function (card) {
        var color = card.getAttribute('data-color');
        var sizes = (card.getAttribute('data-sizes') || '').split(',');
        var price = parseFloat(card.getAttribute('data-price'));

        var colorMatch = activeColors.size === 0 || activeColors.has(color);
        var sizeMatch = activeSizes.size === 0 || sizes.some(function (s) { return activeSizes.has(s); });
        var priceMatch = isNaN(price) || price <= maxPrice;

        var visible = colorMatch && sizeMatch && priceMatch;
        card.style.display = visible ? '' : 'none';
        if (visible) visibleCount++;
      });

      if (emptyMsg) emptyMsg.style.display = visibleCount === 0 ? 'block' : 'none';
    }

    function applySort() {
      var value = sortSelect ? sortSelect.value : 'featured';
      var sorted = cards.slice();

      function num(card, attr) { return parseFloat(card.getAttribute(attr)) || 0; }
      function str(card, attr) { return (card.getAttribute(attr) || '').toLowerCase(); }

      if (value === 'best-selling') sorted.sort(function (a, b) { return num(b, 'data-popularity') - num(a, 'data-popularity'); });
      else if (value === 'az') sorted.sort(function (a, b) { return str(a, 'data-name').localeCompare(str(b, 'data-name')); });
      else if (value === 'za') sorted.sort(function (a, b) { return str(b, 'data-name').localeCompare(str(a, 'data-name')); });
      else if (value === 'price-low') sorted.sort(function (a, b) { return num(a, 'data-price') - num(b, 'data-price'); });
      else if (value === 'price-high') sorted.sort(function (a, b) { return num(b, 'data-price') - num(a, 'data-price'); });
      else if (value === 'newest') sorted.sort(function (a, b) { return str(b, 'data-date').localeCompare(str(a, 'data-date')); });
      else if (value === 'oldest') sorted.sort(function (a, b) { return str(a, 'data-date').localeCompare(str(b, 'data-date')); });

      sorted.forEach(function (card) { grid.appendChild(card); });
    }

    toggles.forEach(function (toggle) {
      toggle.addEventListener('click', function () {
        var type = toggle.getAttribute('data-filter-type');
        var value = toggle.getAttribute('data-filter-value');
        var set = type === 'color' ? activeColors : activeSizes;

        if (set.has(value)) { set.delete(value); toggle.classList.remove('active'); }
        else { set.add(value); toggle.classList.add('active'); }

        applyFilters();
      });
    });

    priceSlider.addEventListener('input', function () {
      if (priceValueEl) priceValueEl.textContent = '£' + priceSlider.value;
      applyFilters();
    });

    if (sortSelect) sortSelect.addEventListener('change', applySort);

    if (clearBtn) {
      clearBtn.addEventListener('click', function () {
        activeColors.clear();
        activeSizes.clear();
        toggles.forEach(function (t) { t.classList.remove('active'); });
        priceSlider.value = priceSlider.max;
        if (priceValueEl) priceValueEl.textContent = '£' + priceSlider.max;
        if (sortSelect) sortSelect.value = 'featured';
        applyFilters();
        applySort();
      });
    }
  })();

  /* =================================================================
     CART — Shopify Cart AJAX API
     Replaces the prototype's localStorage cart. State now lives on
     Shopify's server; every add/update re-fetches /cart.js and
     re-renders the drawer + count from that real data.
     ================================================================= */
  var Cart = (function () {
    var dropdown = document.getElementById('cartDropdown');
    var cartCountEl = document.getElementById('cartCount');

    function money(cents) {
      return (window.Shopify && Shopify.formatMoney)
        ? Shopify.formatMoney(cents, window.themeMoneyFormat || '£{{amount}}')
        : '£' + (cents / 100).toFixed(2);
    }

    function renderDrawer(cart) {
      if (!dropdown) return;
      var itemsEl = dropdown.querySelector('#cartItems');
      if (!itemsEl) return;

      if (cart.item_count === 0) {
        itemsEl.innerHTML = '<div class="cart-empty">Your cart is empty.</div>';
        return;
      }

      var html = cart.items.map(function (item, i) {
        return '<div class="cart-item" data-line="' + (i + 1) + '">' +
          '<img src="' + item.image + '&width=100" alt="' + item.product_title + '">' +
          '<div class="cart-item-info">' +
          '<span class="cart-item-name">' + item.product_title + '</span>' +
          '<span class="cart-item-meta">' + item.variant_title + ' &middot; Qty: ' + item.quantity + '</span>' +
          '</div>' +
          '<span class="cart-item-price">' + money(item.final_line_price) + '</span>' +
          '<button type="button" class="cart-item-remove" data-line="' + (i + 1) + '" aria-label="Remove"><svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><polyline points="3 6 5 6 21 6"/><path d="M19 6l-1 14H6L5 6"/><path d="M10 11v6"/><path d="M14 11v6"/><path d="M9 6V4h6v2"/></svg></button>' +

          '</div>';
      }).join('');

      html += '<div class="cart-subtotal"><span>Subtotal</span><span>' + money(cart.total_price) + '</span></div>';
      html += '<a href="/cart" class="cart-checkout-btn">Go to Checkout</a>';

      itemsEl.innerHTML = html;

      itemsEl.querySelectorAll('.cart-item-remove').forEach(function (btn) {
        btn.addEventListener('click', function () {
          changeLine(btn.getAttribute('data-line'), 0);
        });
      });
    }

    function refresh() {
      return fetch('/cart.js')
        .then(function (r) { return r.json(); })
        .then(function (cart) {
          if (cartCountEl) cartCountEl.textContent = cart.item_count;
          renderDrawer(cart);
          return cart;
        });
    }

    function addItem(id, quantity) {
      return fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ id: id, quantity: quantity || 1 }),
      })
        .then(function (r) {
          if (!r.ok) return r.json().then(function (e) { throw e; });
          return r.json();
        })
        .then(function () { return refresh(); });
    }

    function changeLine(line, quantity) {
      return fetch('/cart/change.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ line: line, quantity: quantity }),
      })
        .then(function (r) { return r.json(); })
        .then(function () { return refresh(); });
    }

    return { addItem: addItem, changeLine: changeLine, refresh: refresh };
  })();

  /* Cart dropdown open/close */
  (function () {
    var dropdown = document.getElementById('cartDropdown');
    var openBtn = document.getElementById('openCart');
    if (!dropdown || !openBtn) return;

    openBtn.addEventListener('click', function (e) {
      var isDesktopDrawer = window.innerWidth > 640;
      if (!isDesktopDrawer) return; // let it fall through to /cart on small screens
      e.preventDefault();
      var isOpen = dropdown.classList.toggle('show');
      if (isOpen) Cart.refresh();
    });

    document.addEventListener('click', function (e) {
      if (!dropdown.classList.contains('show')) return;
      if (dropdown.contains(e.target) || e.target === openBtn) return;
      dropdown.classList.remove('show');
    });
  })();

  /* Wire every "Add to Cart" product form (main product form, homepage
     featured-product section, quick-add cards, etc.) to the Cart API. */
  (function () {
    document.querySelectorAll('form[action*="/cart/add"]').forEach(function (form) {
      form.addEventListener('submit', function (e) {
        e.preventDefault();
        var submitBtn = form.querySelector('.btn-cart');
        var variantSelect = form.querySelector('[name="id"]');
        var qtyInput = form.querySelector('[name="quantity"]');
        if (!variantSelect) return;

        Cart.addItem(variantSelect.value, parseInt(qtyInput ? qtyInput.value : 1, 10) || 1)
          .then(function () {
            if (!submitBtn) return;
            var label = submitBtn.querySelector('span');
            if (!label) return;
            var original = label.textContent;
            label.textContent = 'Added ✓';
            setTimeout(function () { label.textContent = original; }, 1200);
          })
          .catch(function (err) {
            console.error('Add to cart failed', err);
            alert(err && err.description ? err.description : 'Could not add this item to your cart.');
          });
      });
    });
  })();

  /* Sticky add-to-cart bar: shows once the real .btn-cart button scrolls
     out of view; tapping it adds the currently selected variant/qty. */
  (function () {
    var cartBtn = document.querySelector('.btn-cart');
    var stickyBar = document.getElementById('stickyCartBar');
    var stickyBtn = document.getElementById('stickyCartBtn');
    if (!cartBtn || !stickyBar || !stickyBtn) return;

    if ('IntersectionObserver' in window) {
      var observer = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          stickyBar.classList.toggle('show', !entry.isIntersecting);
        });
      }, { threshold: 0 });
      observer.observe(cartBtn);
    }

    stickyBtn.addEventListener('click', function () {
      var form = cartBtn.closest('form');
      var variantSelect = form ? form.querySelector('[name="id"]') : document.querySelector('[name="id"]');
      var qtyInput = form ? form.querySelector('[name="quantity"]') : document.querySelector('[name="quantity"]');
      if (!variantSelect) return;

      Cart.addItem(variantSelect.value, parseInt(qtyInput ? qtyInput.value : 1, 10) || 1)
        .then(function () {
          var label = stickyBtn.querySelector('span');
          if (!label) return;
          var original = label.textContent;
          label.textContent = 'Added ✓';
          setTimeout(function () { label.textContent = original; }, 1200);
        })
        .catch(function (err) {
          console.error('Add to cart failed', err);
        });
    });
  })();

  /* Initial cart count on every page load */
  Cart.refresh();

});

document.addEventListener('DOMContentLoaded', function () {
  const mainImages = document.querySelectorAll('.product-media img.front');

  // Build lightbox
  const lightbox = document.createElement('div');
  lightbox.classList.add('lb-overlay');
  lightbox.innerHTML = `
    <div class="lb-inner">
      <img class="lb-img" src="" alt="">
    </div>
  `;
  document.body.appendChild(lightbox);

  const lbImg = lightbox.querySelector('.lb-img');
  let allImages = [];
  let currentIndex = 0;
  let startX = 0;

  function openLightbox(images, index) {
    allImages = images;
    currentIndex = index;
    lbImg.src = allImages[currentIndex];
    lightbox.classList.add('active');
    document.body.style.overflow = 'hidden';
  }

  function closeLightbox() {
    lightbox.classList.remove('active');
    document.body.style.overflow = '';
  }

  function showImage(index) {
    currentIndex = Math.max(0, Math.min(index, allImages.length - 1));
    lbImg.style.opacity = '0';
    setTimeout(() => {
      lbImg.src = allImages[currentIndex];
      lbImg.style.opacity = '1';
    }, 150);
  }

  // Attach click to each product media block
  document.querySelectorAll('.product-media').forEach(media => {
    const imgs = [...media.querySelectorAll('img')].map(img => img.src);
    media.querySelector('img.front').style.cursor = 'zoom-in';
    media.querySelector('img.front').addEventListener('click', () => openLightbox(imgs, 0));
  });

  // Close on background tap
  lightbox.addEventListener('click', e => {
    if (e.target === lightbox || e.target === lightbox.querySelector('.lb-inner')) closeLightbox();
  });

  // Swipe
  lightbox.addEventListener('touchstart', e => { startX = e.touches[0].clientX; });
  lightbox.addEventListener('touchend', e => {
    const diff = startX - e.changedTouches[0].clientX;
    if (Math.abs(diff) > 50) {
      diff > 0 ? showImage(currentIndex + 1) : showImage(currentIndex - 1);
    }
  });

  // Keyboard
  document.addEventListener('keydown', e => {
    if (!lightbox.classList.contains('active')) return;
    if (e.key === 'ArrowRight') showImage(currentIndex + 1);
    if (e.key === 'ArrowLeft') showImage(currentIndex - 1);
    if (e.key === 'Escape') closeLightbox();
  });
});
